import { Getauth } from "./Auth"

export const setHeader = ()=>{
        const headers={
            headers:{
            "Authorization": Getauth()
        }
    }
    return headers;
}


export const setImgHeader = ()=>{
    const headers={
        headers:{
        'Content-Type': 'multipart/form-data',
        "Authorization": Getauth(),
    }
}
return headers;
}


